module.exports = __webpack_public_path__ + "img/error-404-art.1606df0e.svg";